// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"806d7d10","455":"0f0851c0","977":"22ac6433"}[chunkId] + ".chunk.js";
};